/* "Just in for you" (sections/lsm-for-you.liquid): products that are exactly a model the signed-in customer asked for.
   OSKAR answers with handles only; every card comes from Shopify (sections/lsm-card.liquid), which leaves out anything the
   store cannot sell today. Any failure leaves the row hidden. ?lsm_demo=handle,handle shows chosen products, for checking the look. */
(function () {
  var box = document.querySelector('[data-lsm-foryou]'); if (!box || box.dataset.lsmDone) return; box.dataset.lsmDone = '1'
  var grid = box.querySelector('[data-lsm-foryou-grid]')
  var demo = new URLSearchParams(location.search).get('lsm_demo')
  var OK = /^[a-z0-9][a-z0-9-]{0,254}$/, KEY = 'lsm-foryou', KEEP = 10 * 60 * 1000

  function handles() {
    if (demo) return Promise.resolve(demo.split(','))
    if (!box.dataset.signedIn) return Promise.resolve([])
    try { var c = JSON.parse(sessionStorage.getItem(KEY) || 'null'); if (c && Date.now() - c.at < KEEP) return Promise.resolve(c.handles) } catch (e) {}
    return fetch(box.dataset.api, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { handles: [] } })
      .then(function (d) { var h = Array.isArray(d.handles) ? d.handles : []; try { sessionStorage.setItem(KEY, JSON.stringify({ at: Date.now(), handles: h })) } catch (e) {} return h })
  }
  function card(handle) {
    return fetch('/products/' + handle + '?section_id=lsm-card', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : '' })
      .then(function (html) { return html ? new DOMParser().parseFromString(html, 'text/html').querySelector('[data-lsm-card]') : null })
      .catch(function () { return null })
  }
  handles().then(function (list) {
    list = (list || []).filter(function (h) { return typeof h === 'string' && OK.test(h) }).slice(0, 8)
    // the product being looked at is not suggested to itself
    var here = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1]
    list = list.filter(function (h) { return h !== here })
    if (!list.length) return
    return Promise.all(list.map(card)).then(function (cards) {
      cards = cards.filter(Boolean); if (!cards.length) return
      cards.forEach(function (c) { grid.appendChild(document.importNode(c, true)) })
      box.hidden = false
    })
  }).catch(function () {})
})()
